import React, {Component} from 'react';
import {connect} from 'react-redux';
import CombinationChecking from './combination-checking';
import CombinationExposure from './combination-exposure';
import StackCombinationsTotalMinExposure from './stack-combinations-total-min-exposure';
import Tooltip from 'components/atoms/tooltip';

class CombinationOptions extends Component {
    render() {
        const {stacking} = this.props;
        const combinations = stacking.getCombinations();

        let combinationBlocks = [];
        Object.keys(combinations).map((comboKey) => {
            combinationBlocks.push(
                <div key={comboKey} className="stack-box">
                    <CombinationChecking comboKey={comboKey} />
                    <div className="min-max-group">
                        <div className="percent-in">
                            <CombinationExposure exposureType="min" comboKey={comboKey} />
                            <span className="percent">%</span>
                        </div>
                        <div className="percent-in">
                            <CombinationExposure exposureType="max" comboKey={comboKey} />
                            <span className="percent">%</span>
                        </div>
                    </div>
                </div>,
            );
        });

        return (
            <div className="nhl-stack-combinations">
                <div className="heading-box">
                    <h3>
                        Choose stack combinations <Tooltip subject="D is always included in 4 player stacks." />
                    </h3>
                    <StackCombinationsTotalMinExposure />
                </div>
                <div className="stack-box-holder">{combinationBlocks}</div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(CombinationOptions);
